module.exports.version = 'v11.10.0-314b1e52';
